import { defineAsyncComponent } from 'vue';

export function useBlocks() {
  const files = import.meta.glob('@/components/blocks/**/*.vue');
  const blockComponents = {};

  for (const path in files) {
    const fileName = path.split('/').pop().replace('.vue', '');
    const key = fileName
      .replace(/^Block/, '')
      .replace(/([A-Z])/g, '_$1')
      .toLowerCase()
      .replace(/^_/, '');

    blockComponents[key] = defineAsyncComponent(files[path]);
  }

  return blockComponents;
}